import Backbone from "backbone";
import * as Mustache from "mustache";

const TranslationDirectionView = Backbone.View.extend({
  /**
   * Toggles between readerTranslations 'on' or 'off'
   *
   * off:   Displays a cross
   *  on:   Displays a small arrow pointing right
   *
   * @param {User}  options.model
   */
  tagName: "i",
  initialize: function (options) {
    this.options = options;
    this.render();
    this.listenTo(
      this.model,
      "change:readerTranslations",
      this.render.bind(this)
    );
  },
  template:
    "{{#readerTranslations}}" +
    "  {{#options.textMode}}to{{/options.textMode}}" +
    '  {{^options.textMode}}<i class="icon-arrow-right"></i>{{/options.textMode}}' +
    "{{/readerTranslations}}" +
    '{{^readerTranslations}}<i class="icon-remove"></i>{{/readerTranslations}}',
  render: function () {
    this.$el.html(
      Mustache.render(this.template, {
        options: this.options,
        readerTranslations: this.model.get("readerTranslations") !== "off",
      })
    );
  },
  events: {
    click: "toggle",
  },
  toggle: function () {
    this.model.save(
      {
        readerTranslations:
          this.model.get("readerTranslations") === "off" ? "on" : "off",
      },
      {
        patch: true,
        success: function () {
          //debugger;
        },
      }
    );
  },
});

export default TranslationDirectionView;
